export default __webpack_public_path__ + "static/media/blog-img96.c80e053a.jpg";